interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function StatsIcon(props: Props) {
  const { size = 18, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.28235 16V1M2 16V6M10.5647 16V9.25M14.8471 16V4.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
